<template>
  <div class="header">
    <img class="logo" src="@/assets/customs-logo-20260610.jpg"/>
    <span v-if="host === '172.20.6.65'" class="test">測試</span>
    <div class="title-box">
      <span class="title-span">
        <!-- {{ $t('common.Carrycashandnamelessnegotiableinstruments') }}
        <br/>
        {{ $t('common.Declarationofentryandexit') }} -->
        <span>{{ $t('common.Carryingcashandnameless') }}</span>
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Header",
    props: {
      type: String
    },
    data () {
      return {
        host: location.host
      };
    }
  };
</script>
<style lang="scss" scope>
  .header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    z-index: 1;
    .logo {
      width: 370px;
      height: 125px;
      margin-bottom: 21px;
      margin-left: 20px;
    }
    .test {
      position: absolute;
      color: #f00;
      left: 340px;
      top: 8px;
    }
    .title-box {
      width: 100%;
      min-height: 175px;
      background-color: #43a6df;
      border-radius: 40px 40px 0 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .title-span {
        text-align: center;
        width: 690px;
        min-height: 126px;
        font-family: PingFang SC;
        font-size: 46px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 55px;
        letter-spacing: 1px;
        color: #fff;
      }
    }
  }
</style>
